export type PaywallFlow = "soft_3_exp" | "hard_no_card_3d";

// Change to "hard_no_card_3d" to switch every free user to that flow
export const PAYWALL_FLOW: PaywallFlow = "soft_3_exp";
